import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ProfilePane from './ProfilePane';
import ProfileConfigurePane from './ProfileConfigurePane';
export default class RootMasqueradePane extends UserPage {
  loading = true;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }
  pageContentComponent() {
    if (!this.user) return null;
    if (this.user.canEditMasqueradeProfile()) return m(ProfileConfigurePane, {
      user: this.user
    });else return m(ProfilePane, {
      user: this.user
    });
  }
  show(user) {
    super.show(user);
    if (!app.forum.attribute('canViewMasquerade') && !user.canEditMasqueradeProfile()) {
      m.route.set(app.route.user(user));
    }
    this.loading = false;
    m.redraw();
  }
  content() {
    return m("div", {
      class: "MasqueradeRoot"
    }, this.loading && m(LoadingIndicator, null), this.pageContentComponent());
  }
}
flarum.reg.add('fof-masquerade', 'forum/panes/RootMasqueradePane', RootMasqueradePane);